import type { AdminLanguage } from '../../services/i18nService';

/**
 * Whether the signed-in user is a language admin for this language. Non-managers
 * only receive their own languages from the server (with admins stripped).
 */
export function isAssignedTo(language: AdminLanguage, email: string, isManager: boolean): boolean {
  if (!isManager) return true;
  const me = email.trim().toLowerCase();
  return (language.admins || []).some((a) => a.trim().toLowerCase() === me);
}

export function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] || '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
